import { Select, Skeleton, Typography, theme } from "antd";
import { EntityLabel } from "components/Shared/Labels/EntityLabel";
import { ImageTypes } from "enums/imageTypes";
import { useFetchEntities, useFetchEntity } from "hooks/useEntitiesApi";
import { useIntl } from "react-intl";
import { Link, useNavigate, useParams } from "react-router-dom";

const { useToken } = theme;

export const EntitySelect = () => {
  const { token } = useToken();
  const { formatMessage } = useIntl();
  const { customerId, sport, organizationId, entityId, seasonId } = useParams();
  const navigate = useNavigate();
  const { isLoading: isEntitiesLoading, data: entitiesResponse } = useFetchEntities();
  const entities = entitiesResponse?.data || [];

  const { isLoading: isEntityLoading, data: entityResponse } = useFetchEntity({
    entityId: entityId || "",
  });
  const entity = entityResponse?.data?.[0];

  const onEntityChange = (newEntityId) => navigate(`${customerId}/${sport}/${organizationId}/entities/${newEntityId}`);

  if (isEntityLoading) {
    return <Skeleton.Input active={isEntityLoading} />;
  }

  if (!entity) {
    return <Typography.Text>{formatMessage({ id: "breadcrumbs.entities" })}</Typography.Text>;
  }

  const imageUrl = entity.images?.filter((x) => x?.imageType === ImageTypes.Logo)?.[0]?.url;

  if (seasonId) {
    return (
      <Link to={`${customerId}/${sport}/${organizationId}/entities/${entityId}`}>
        <EntityLabel
          imageUrl={imageUrl}
          size={25}
          title={
            <Typography.Text style={{ color: token.colorPrimary }} strong>
              {entity?.nameFullLocal}
            </Typography.Text>
          }
        />
      </Link>
    );
  }

  return (
    <EntityLabel
      imageUrl={imageUrl}
      size={25}
      title={
        <Select
          popupMatchSelectWidth={false}
          variant="borderless"
          showSearch
          onChange={onEntityChange}
          filterOption={(input, option) => `${option?.label ?? ""}`.toLowerCase()?.includes(input.toLowerCase())}
          optionRender={({ data: option }) => {
            return <EntityLabel imageUrl={option?.img} title={option?.label} size={25} />;
          }}
          defaultValue={entityId}
          loading={isEntitiesLoading}
          options={entities.map((x) => {
            return {
              label: x?.nameFullLocal,
              value: x?.entityId,
              img: x?.imageLogoUrl,
            };
          })}
        />
      }
    />
  );
};
